import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LiaService } from '@app/shared/services/lia.service';
import { ApplicationService } from '@app/shared/application/application.service';
import { AppComponentBase } from '@shared/common/app-component-base';

@Injectable()
export class LiaGuard implements CanActivate, CanDeactivate<AppComponentBase> {

    constructor(
        private liaService: LiaService,
        private applicationService: ApplicationService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
       return this.liaService.getLia(this.applicationService.caseId).pipe(map(() => true));
    }

    canDeactivate(component: AppComponentBase): boolean | Observable<boolean> {
        this.liaService.closeLia();
        return true;
    }
}
